import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState } from 'react';
import { InputText, Icon } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";
const PasswordField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    0: showPassword,
    1: setShowPassword
  } = useState(false);

  function handleToggleShowPassword(event) {
    event.preventDefault();
    setShowPassword(prevState => !prevState);
  }

  return /*#__PURE__*/_jsx(InputText, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    type: showPassword ? InputText.Type.Text : InputText.Type.Password,
    suffix: /*#__PURE__*/_jsx("span", {
      onClick: handleToggleShowPassword,
      className: "u-cursor-pointer",
      "data-testid": "auth-password-eye-icon",
      children: /*#__PURE__*/_jsx(Icon, {
        name: showPassword ? 'eye' : 'eye-denied',
        size: Icon.Size.Small
      })
    })
  }));
});
export default PasswordField;